import { Outlet } from '@tanstack/react-router'
import { Toaster } from 'sonner'
import { UpdatePrompt } from '@/features/pwa/update-prompt'
export function RootLayout() {
  return (
    <>
      <Outlet />
      <UpdatePrompt />
      <Toaster richColors position="bottom-right" />
    </>
  )
}
